import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';
@Component({
	selector: 'app-offers-catalog',
	templateUrl: './offers-catalog.component.html',
	styleUrls: ['./offers-catalog.component.css'],
})
export class OffersCatalogComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/offer/catalog/';
	protected parentComponent = 'codebook/catalogList';
	pageTitle = 'Dodawanie';
	pageFunction = 'edit';

	codebook;

	data = {
		id: null,
		name: null,
		multimedia: { id: '', name: '', url: '' },
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/15/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected convertData(data: any) {
		if (data.multimedia === null) {
			data.multimedia = {
				id: '',
				name: '',
				url: '',
			};
		}

		return data;
	}

	protected pageTitleGenerate(): string {
		return `Słowniki -> 
			${this.codebook.name}
			 -> 
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	protected getApiUrl(): string {
		return '/offer/catalog/' + this.data.id + '/';
	}

	protected submitConvert(data: any) {
		return {
			id: data.id,
			name: data.name,
			multimedia: data.multimedia.id,
		};
	}

	onFileSelected(event): void {
		this.bag.upload('/multimedia/file/', event.target.files[0], (result, error) => {
			this.data.multimedia = result;
		});
	}

	deleteImage() {
		this.data.multimedia = { id: '', url: '', name: '' };
	}
}
